var qq = require('./qq');
var getScript = require("@tencent/txmv-core/util/getScript");
var ua = require('@tencent/txv.ua')();

function check(config, callback) {
	if (window.x5 && x5.ios && x5.ios.getMobileAppSupport) {
		var a = {
			"scheme": config.pkgurl
		};
		x5.ios.getMobileAppSupport(a, function (rs) {
			callback(null, rs && rs.isSupportApp == 1 ? 1 : 0);
		}, function () {
			callback(null, 0);
		});
	} else {
		callback(null, 0);
	}
	//超过300ms没结果就算没安装
	setTimeout(function () {
		callback(null, 0);
	}, 300)
}

module.exports = function (config, _callback) {
	var callbacked = false;
	//只callback一次
	var callback = function () {
		if (callbacked) {
			return;
		}
		callbacked = true;
		_callback.apply(this, arguments);
	};

	//蛋疼用手q打开qq浏览器,ua是qq浏览器但是判断得用手qapi判断
	if (!ua.os.iphone && window.QQApi && QQApi.checkAppInstalled) {
		return qq.apply(this, arguments);
	}

	if (!ua.os.iphone && window.x5mtt && window.x5mtt.isApkInstalled) {
		var _flag = window.x5mtt.isApkInstalled('{"packagename": ' + config.pkg + '}');
		callback(null, _flag != -1 ? 1 : 0);
	} else if (ua.os.iphone && parseInt(ua.os.version) > 5) {

		//if (tvp.app.loadMqqDefer) {
		//	return tvp.app.loadMqqDefer;
		//}
		if (window.x5) {
			check(config, callback);
		} else {
			var apiurl = '//res.imtt.qq.com/browser_lightapp/QQBrowserApi/getCryptext/browser_interface_getCryptext.js';
			getScript(apiurl, function () {
				window.x5 ? check(config, callback) : callback(null, 2);
			});
		}
	} else {
		callback(null, 2);
	}

	setTimeout(function () {
		callback(null, 2);
	}, 6000);
};